import React from "react";

const SpinningLoader = (props) => {
  return(
    <div className={`align-center vertical-align-middle full-height ${props.containerClass || ""}`}>
      <div className="m-auto">
        <span className="flex-column align-center">
          <span className={`spinning-loader ${props.loaderClass}`}></span>
          {props.loadingText && <span className="mt-2 px-4">{props.loadingText}</span>}
        </span>
      </div>
    </div>
  )
}

export default SpinningLoader;